import { createContext, RefObject } from 'react';

export const WorkflowScrollContext = createContext<RefObject<HTMLElement> | undefined>(undefined);
